import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading = new Subject<boolean>();
  private isShowing: boolean = false;
  show() {
    this.isShowing = true;
    var that = this;
    setTimeout(function () {
      that.isLoading.next(that.isShowing);
    }, 750);
  }
  hide() {
    this.isShowing = false;
    this.isLoading.next(this.isShowing);
  }
}
